/* eslint-disable @typescript-eslint/method-signature-style */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { JSXElement, Component, createSignal, createEffect } from 'solid-js';
import { noShadowDOM } from 'solid-element';
export interface ImageProps {
  src: string;
  className?: string;
  errImg?: string;
  onClick?: () => void;
}

const Image: Component<ImageProps> = (props): JSXElement => {
  noShadowDOM();

  let imgRef: HTMLImageElement | undefined;
  const [loading, setLoading] = createSignal<boolean>(true);
  const [error, setError] = createSignal<boolean>(false);

  // Reactive getters for props
  const getSrc = () => props.src || '';
  const getClassName = () => props.className || 'thumbnail micro';
  const getErrImg = () => props.errImg || '';

  // Reset loading and error state when src changes
  createEffect(() => {
    if (getSrc()) {
      setLoading(true);
      setError(false);
    }
  });

  const handleLoad = () => {
    setLoading(false);
  };

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  const handleClick = (event: MouseEvent) => {
    // Emit custom event for React wrapper
    if (imgRef) {
      const customEvent = new CustomEvent('image-click', {
        detail: { originalEvent: event },
        bubbles: true,
      });
      imgRef.dispatchEvent(customEvent);
    }

    // Call onClick if provided
    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <>
      {loading() && <i class="icon-font tc-icon-spinner-dark" />}
      <img
        ref={imgRef}
        src={!error() ? getSrc() : getErrImg()}
        class={loading() ? 'd-none' : getClassName()}
        onLoad={handleLoad}
        onError={handleError}
        onClick={handleClick}
      />
    </>
  );
};

export default Image;
